module.exports = __webpack_public_path__ + "img/quan.2a1f5e85.svg";